import { useHead, useRuntimeConfig } from "#imports";
import { useCheckoutStore } from "~/store/checkout";
import { Partner } from "~/enums/partner";
import { InstitutionpartnerId } from "~/enums/institution";
import { OrderCheckoutType } from "~/enums/orderCheckoutType";
let isLoaded = false;
export default defineNuxtRouteMiddleware((to,from) => {
		const lpAnimaRoute = ['/lp/anima','/admin/orders']
		const mktplaceRoute = [
			'/checkout/personal-data',
			'/checkout/address',
			'/checkout/subscription',
			'/checkout/information'			
		];
		let isAnimaProduct = false;
		
		if(!lpAnimaRoute.includes(to.path)) {
			const checkout = useCheckoutStore();
			const product = toRaw(checkout.get_product());
			isAnimaProduct = (product?.institution?.partner_id === InstitutionpartnerId.ANIMA && product?.product_type == OrderCheckoutType.SUBSCRIPTION)
		}
		const appEnv = useRuntimeConfig().public.appEnv;
		if(
			(
				lpAnimaRoute.includes(to.path) || (mktplaceRoute.includes(to.path) && isAnimaProduct)
			)  
			&& isLoaded === false
			&& ["prod"].includes(appEnv)
		) {
			useHead(
				{
					script: [
						{
							key: 'gtmanima',
							children: `
									(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
									new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
									j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
									'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
									})(window,document,'script','dataLayerAnima','GTM-TJ39QC3');
									window.dataLayerAnima = window.dataLayerAnima || [];
									function gtagAnima(){dataLayerAnima.push(arguments);}
									gtagAnima('js', new Date());
									(window.gtagAnima_old || []).forEach((evt) => window.gtagAnima('event', ...evt));
								`,
							type: 'text/javascript'
						}
					]
				}
			);

			isLoaded = true;
			
		}
	
	
})
